import { render, staticRenderFns } from "./PlayerDashboard.vue?vue&type=template&id=75193bdd&scoped=true&"
import script from "./PlayerDashboard.vue?vue&type=script&lang=js&"
export * from "./PlayerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerDashboard.vue?vue&type=style&index=0&id=75193bdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75193bdd",
  null
  
)

export default component.exports